// removed by extract-text-webpack-plugin
module.exports = {"block":"_3t9fvPIOGMxlu4Js6lQWQt","zebra":"XjDYPXYXEGtoKNHjzIJy2","yellow":"EpKF3XQyixN3E6Ts-THn6","darkgray":"_1GRYqwHgzWz1YI2Ks3ksvK","lightgray":"_3-HSr-XYjn_fd-nj5zqpIU","white":"_13QVvJzvbpP1npyP_ZJMRA","wrapper":"_2t7__QJR2_UGpoOHcU00ps","content":"_1dy8yNDTyBy9un4vS2_NcJ","heading":"_3KxDbHX52yQUIQsIhPaUTo","linkedArticle":"_1_h04TiyUVxYcLajeRqfFU","item":"_36lPKBExrEUb4b_2CU42Ri","wysiwyg":"_3jGPdM2urjBore1SMyym20","title":"_2FPNIl6fZ11mEOCFd5Cgtz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureListBlock/FeatureListBlock.module.scss
// module id = 761
// module chunks = 0